import { JSX } from "react";
import { AccuracyGapAnalysisStatus } from "../projects/enumerators";
import { QESAlert } from "./qes-standards";

function getAGABanner(showAccuracyGapAnalysis: boolean, agaStatus: AccuracyGapAnalysisStatus) : JSX.Element {
  const showBanner = showAccuracyGapAnalysis && !(agaStatus == AccuracyGapAnalysisStatus.Succeeded || agaStatus == AccuracyGapAnalysisStatus.Unknown)
  const showError = agaStatus == AccuracyGapAnalysisStatus.Failed || agaStatus == AccuracyGapAnalysisStatus.Canceled;

  return showBanner ?
    !showError ? (
      <QESAlert type="warning" key="agaResultsProcessing" persist={true}>
        <strong>Warning! </strong>
        Accuracy Gap Analysis is still calculating.  It is safe to publish this project, but the end-user will not see Accuracy Gap Analysis if you do so.
      </QESAlert>
    ) :
      (
        <QESAlert type="danger" key="agaResultFailed" persist={true}>
          <strong>Error! </strong>
          Accuracy Gap Analysis calculation failed.  It is safe to publish this project, but the end-user will not see Accuracy Gap Analysis if you do so.
        </QESAlert>
      )
    : null;
}

export default getAGABanner;
